import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {Mutation} from 'react-apollo';


export const CHANGE_LOCALE_FOR_USER = gql`
mutation changeLanguage($id: ID!, $language: String!) {
  changeLanguage(globalId: $id, language: $language) {
    user {
      id
      created
      firstName
      lastName
      language
      email
      emailConfirmed
      born
      gender
    }
    ok
    errorMessage
  }
}
`;


export class WithChangeLocaleForUser extends React.Component {

    static propTypes = {
        children: PropTypes.func.isRequired,
        onCompleted: PropTypes.func
    };

    changeLocale = (mutate, userId, locale) => {
        const variables = {id: userId, language: locale};

        return mutate({variables});
    };

    render() {
        return (
            <Mutation mutation={CHANGE_LOCALE_FOR_USER} onCompleted={this.props.onCompleted}>
                {(mutate, {loading, error}) => (
                    this.props.children((userId, locale) => this.changeLocale(mutate, userId, locale), {loading, error})
                )}
            </Mutation>
        );
    }
}
